// src/templates/client1/Footer.jsx
// Footer personalizado para cliente específico
// Componente vacío - no muestra nada

import React from 'react';

function Footer() {
  // Retornar null para no mostrar el footer
  return null;
}

export default Footer;

